
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eZIhV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0e6ea26494fd8c3c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $0e6ea26494fd8c3c$export$2e2bcd8739ae039 = {
    'confluence.error.panel.refresh.app': "Actualizar aplicaci\xf3n",
    'confluence.error.panel.reload.page': "Recargar p\xe1gina",
    'confluence.icon.label': 'Icono',
    'confluence.modal.dialog.close.modal.button': 'Cancelar',
    'confluence.select.required.field.message': 'Este campo es obligatorio.',
    'confluence.text.area.required.field.message': 'Este campo es obligatorio.',
    'confluence.textfield.validator.email': "Introduce un correo electr\xf3nico v\xe1lido.",
    'confluence.textfield.validator.number': "Introduce un n\xfamero v\xe1lido.",
    'confluence.textfield.validator.required.field.message': 'Este campo es obligatorio.',
    'confluence.textfield.validator.telephone': "Introduce un n\xfamero de tel\xe9fono v\xe1lido.",
    'confluence.threeLOPrompt.modal.access.required.title': 'Acceso obligatorio',
    'confluence.threeLOPrompt.modal.error.title': 'Error',
    'confluence.threeLOPrompt.modal.no.authURL.error-message': "No se ha encontrado la URL de consentimiento. Actualiza la p\xe1gina y vuelve a intentarlo.",
    'confluence.threeLOPrompt.no.authURL.error-message': "No se ha encontrado la URL de consentimiento. Actualiza la p\xe1gina y vuelve a intentarlo.",
    'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Permitir acceso',
    'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Configurar acceso',
    'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Se ha producido un error al autenticar.',
    'confluence.threeLOPrompt.use-auth.default.prompt.message': "Para que se muestre {appString}, debes permitir que la aplicaci\xf3n acceda a los productos de Atlassian en tu nombre.",
    'confluence.threeLOPrompt.use-auth.external.auth.prompt.message': '{appString} requiere un acceso adicional a tu cuenta.',
    'confluence.threeLOPrompt.use-auth.external.auth.warning.message': "Advertencia de autenticaci\xf3n externa",
    'confluence.threeLOPrompt.use-auth.this.app.lower.message': "esta aplicaci\xf3n",
    'confluence.threeLOPrompt.use-auth.this.app.upper.message': "Esta aplicaci\xf3n",
    'confluence.user.group.unknown.user.message': 'Usuario desconocido',
    'confluence.user.picker.empty.field.error.message': 'Este campo es obligatorio.',
    'confluence.user.unknown.user.message': 'Usuario desconocido',
    'forge-ui.form.submit-button.text': 'Enviar'
};

});


//# sourceMappingURL=es.1d95a4ad.js.map
